import React, { useState } from 'react';
import { Layout, Row, Col, Typography, Card, Button } from 'antd';
import { CheckOutlined, ArrowRightOutlined, UserOutlined, TeamOutlined, CrownOutlined, BankOutlined } from '@ant-design/icons';
import './Pricing.scss';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const Pricing: React.FC = () => {
  const [isYearly, setIsYearly] = useState(false);

  const plans = [
    {
      name: 'Free',
      monthlyPrice: 499,
      yearlyPrice: 4990,
      description: 'Simple invoicing, reports, taxes, and data backup.',
      features: ['2 Users', '1 Partners', '10 Products', '1 Invoice'],
      icon: <UserOutlined />
    },
    {
      name: 'Basic',
      monthlyPrice: 599,
      yearlyPrice: 5990,
      description: 'Advanced invoicing, inventory, analytics, and multi-user access.',
      features: ['5 Users', '5 Partners', '100 Products', '10 Invoice'],
      icon: <TeamOutlined />
    },
    {
      name: 'Premium',
      monthlyPrice: 999,
      yearlyPrice: 9990,
      description: 'Automation, API, multi-branch, and workflow management.',
      features: ['50 Users', '10 Partners', '1000 Products', '1000 Invoice'],
      icon: <CrownOutlined />
    },
    {
      name: 'Enterprise',
      monthlyPrice: 1499,
      yearlyPrice: 14990,
      description: 'AI insights, ERP integration, and enterprise security.',
      features: ['1000 Users', 'Unlimited Partners', 'Unlimited Products', 'Unlimited Invoice'],
      icon: <BankOutlined />
    }
  ];

  return (
    <Layout className="pricing-layout">
      <Content>
        <div className="pricing-container">
          <div className="pricing-header">
            <div className="pricing-badge">Pricing & Plans</div>
            <Title level={1} className="pricing-title">
              Choose the Perfect Plan to Suit your Needs.
            </Title>
            <Paragraph className="pricing-description">
              Whether you're an individual, a small team, or a growing enterprise, we have a plan that aligns perfectly with your goals.
            </Paragraph>
            
            <div className="billing-toggle">
              <div className="toggle-container">
                <button 
                  className={`toggle-option ${!isYearly ? 'active' : ''}`}
                  onClick={() => setIsYearly(false)}
                >
                  Monthly
                </button>
                <button 
                  className={`toggle-option ${isYearly ? 'active' : ''}`}
                  onClick={() => setIsYearly(true)}
                >
                  Yearly
                </button>
              </div>
            </div>
          </div>

          <Row gutter={[24, 24]} className="pricing-cards">
            {plans.map((plan, index) => (
              <Col xs={24} sm={12} lg={6} key={index}>
                <Card className="pricing-card" hoverable>
                  <div className="plan-header">
                    <div className="plan-period">{isYearly ? 'Yearly' : 'Monthly'}</div>
                    <div className="plan-icon">{plan.icon}</div>
                  </div>
                  
                  <div className="plan-content">
                    <Title level={3} className="plan-name">{plan.name}</Title>
                    <Paragraph className="plan-description">
                      {plan.description}
                    </Paragraph>
                  </div>

                  <div className="plan-price">
                    <Text className="price">
                      RM {isYearly ? plan.yearlyPrice : plan.monthlyPrice}
                    </Text>
                  </div>

                  <div className="plan-features">
                    <Title level={5}>What's included</Title>
                    <ul>
                      {plan.features.map((feature, featureIndex) => (
                        <li key={featureIndex}>
                          <CheckOutlined className="feature-check" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Button 
                    type="default" 
                    size="large" 
                    block
                    className="plan-button"
                  >
                    Buy Plan <ArrowRightOutlined />
                  </Button>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default Pricing; 